import { useParams, Navigate } from "react-router-dom";
import { SpaceContent } from "./SpaceContent";

function SpacePage() {
  const { spaceId, section } = useParams<{
    spaceId: string;
    section: string;
  }>();
  if (!spaceId) {
    return <Navigate to="/" replace />;
  }
  return <SpaceContent key={spaceId} spaceId={spaceId} section={section} />;
}

export default SpacePage;
